import { TableConfig } from "@/components/tables/ReusableTablePage";
import { getOrdersColumns } from "./ordersColumns";
import { getOrderRowActions } from "./ordersRowActions";

export const getOrdersTableConfig = (): TableConfig => {
  return {
    tableName: "orders",
    pageTitle: "Order Management",
    primaryKeyField: "id",
    columns: getOrdersColumns(),
    rowActions: getOrderRowActions(),
    defaultSortColumn: "created_at",
    defaultSortDirection: "desc",
    searchFields: ["order_number", "status"],
    addButtonText: "",
    onRowClick: (order: any) => {
      // Navigation will be handled by the row action
    }
  };
};